const swiper = new Swiper('.five-favs-carousel .swiper', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    mousewheel: {
        forceToAxis: true,
    },
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        989: {
            slidesPerView: 3,
        },
    }
  });